import { ICON_MAPPINGS } from './LordIconMapping';
import { jsx as _jsx } from "react/jsx-runtime";
const isBrowser = typeof window !== 'undefined';
if (isBrowser) {
  import('@lordicon/element').then(_ref => {
    let {
      defineElement
    } = _ref;
    import('lottie-web').then(lottie => {
      defineElement(lottie.default.loadAnimation);
    });
  });
}
/**
 * LordIcons are a [third party](https://lordicon.com/docs) animated icon library used by
 * Embedded Studio to allow org admins to customize various features with an icon that
 * fits their campaign.
 */
export const LordIcon = _ref2 => {
  let {
    name,
    animation,
    primaryColor = '#000',
    secondaryColor = '#000',
    size = 25,
    trigger = 'in',
    variant = 'outline',
    stroke = 'regular'
  } = _ref2;
  const icon = ICON_MAPPINGS[name];
  return /*#__PURE__*/_jsx("lord-icon", {
    style: {
      height: size,
      width: size
    },
    src: icon.s3Url[variant],
    state: animation,
    trigger: trigger,
    stroke: stroke,
    colors: `primary:${primaryColor},secondary:${secondaryColor}`
  });
};